import React, { useContext, useEffect, useState } from "react"
import { Button, Container, Nav, Navbar } from "react-bootstrap"
import Logo from "../../images/logo-h@4x-min.png"
import { StyledLink } from "../StyledLink"
import { ModalContext } from "../layout";
import "./styles.scss"

const NavBar = ({ location, isBookDemoPage }) => {
  let width
  const path = location.pathname ? location.pathname : ""

  const [screenWidth, setScreenWidth] = useState(width)
  const [, setShowModal] = useContext(ModalContext)
  const openModal = () => setShowModal(true)

  function debounce(func, wait, immediate) {
    let timeout
    return function () {
      const context = this,
        args = arguments
      const later = function () {
        timeout = null
        if (!immediate) func.apply(context, args)
      }
      const callNow = immediate && !timeout
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
      if (callNow) func.apply(context, args)
    }
  }
  /*
    Check for the window element.
    Needed for server size rendering of Gatsby else use of window.innerHeight/Width will cause build failures.
  */
  if (typeof window !== `undefined`) {
    width = window.screen.availWidth
  }

  useEffect(() => {
    /*
      Debounce function for performance to check window resizing every 1000ms instead of of every ms.
      Upon resize, set new dimension to state.
      Update 1000 value as needed. Note: 1000 = 1 second
    */
    const debouncedHandleResize = debounce(function handleResize() {
      setScreenWidth(window.screen.availWidth)
    }, 10000)
    // Listen for window resize and run the debounce resize function above.
    window.addEventListener(`resize`, debouncedHandleResize)
    // Remove the event listener if resizing stopped.
    return () => window.removeEventListener(`resize`, debouncedHandleResize)
  }, [])

  return (
    <Navbar
      bg="white"
      expand="lg"
      sticky="top"
      fluid
      className="mx-auto justify-content-center"
      id="nav"
    >
      <Container>
        <StyledLink to="/">
          <Navbar.Brand className="mx-auto">
            <img
              src={Logo}
              alt="Team Coaches"
              className="nav-logo"
              style={{
                maxWidth: "9em",
                maxHeight: "1.875em",
              }}
            />
          </Navbar.Brand>
        </StyledLink>
        {isBookDemoPage ? "" : (
            <>
              <Navbar.Toggle
                  data-target="basic-navbar-nav"
                  aria-controls="basic-navbar-nav"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                  className="icon"
              />
              <Navbar.Collapse
                  id="basic-navbar-nav"
                  className="mx-auto justify-content-end"
              >
                <Nav className="align-items-center">
                  <StyledLink to="/">Home</StyledLink>
                  <StyledLink to="/product">Product</StyledLink>
                  <Nav.Link href="https://blog.teamcoach.es/">Blog</Nav.Link>
                  <Button
                      variant="primary"
                      style={{
                        background: "#1F7ABF",
                        borderRadius: "8px",
                      }}
                      onClick={openModal}
                  >
                    Book a demo
                  </Button>
                  <Nav.Link rel="noopener" href="https://app.teamcoach.es/login">
                    <Button
                        variant="secondary"
                        style={{
                          borderRadius: "8px",
                        }}
                    >
                      Login
                    </Button>
                  </Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </>
          )}
      </Container>
    </Navbar>
  )
}

export default NavBar
